const TOPICS = [
  { tag: '韩国动作片', count: '2.8万热度', icon: 'ri-sword-line' },
  { tag: '日本动画电影', count: '3.5万热度', icon: 'ri-ancient-gate-line' },
  { tag: '日韩爱情片', count: '2.1万热度', icon: 'ri-heart-line' },
  { tag: '悬疑惊悚', count: '1.9万热度', icon: 'ri-ghost-line' },
  { tag: '韩国历史剧', count: '1.6万热度', icon: 'ri-history-line' },
  { tag: '日本恐怖片', count: '2.3万热度', icon: 'ri-skull-line' },
  { tag: '喜剧搞笑', count: '1.8万热度', icon: 'ri-emotion-laugh-line' },
  { tag: '科幻奇幻', count: '1.5万热度', icon: 'ri-rocket-line' },
  { tag: '纪录片', count: '0.9万热度', icon: 'ri-camera-line' },
  { tag: '经典老片', count: '2.6万热度', icon: 'ri-vip-crown-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 mb-8">当前最受关注的日韩影视话题分类</p>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.tag}
              href="#index"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70 cursor-pointer no-underline hover:bg-primary-50 hover:border-primary-200 transition-colors group"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50">
                <i className={`${topic.icon} text-sm text-foreground-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}